/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function () {
  function removeControls(video) {
    video.controls = false;
    video.removeAttribute('controls');
    video.muted = true;
    video.setAttribute('muted', '');
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.loop = true;
    video.setAttribute('loop', '');
  }

  function activateSlide(slide) {
    const deferred = slide.querySelector('deferred-media');
    if (!deferred) return;

    // Se ja foi loaded pelo tema, so trata o video
    if (deferred.hasAttribute('loaded')) {
      const video = deferred.querySelector('video:not(template video)');
      if (video) {
        removeControls(video);
        video.play().catch(() => {});
      }
      return;
    }

    // Extrai o video do <template> manualmente
    const template = deferred.querySelector('template');
    if (!template) return;

    const content = template.content.cloneNode(true);
    const video = content.querySelector('video');
    if (!video) return;

    removeControls(video);

    // Injeta no DOM (substitui o template)
    deferred.appendChild(content);
    deferred.setAttribute('loaded', 'true');

    // Esconde o botao poster
    const poster = deferred.querySelector('.deferred-media__poster');
    if (poster) poster.style.display = 'none';

    // Pequeno delay para o browser registar o elemento antes do play
    setTimeout(() => {
      const liveVideo = deferred.querySelector('video:not(template video)');
      if (liveVideo) {
        removeControls(liveVideo);
        liveVideo.play().catch(() => {});
      }
    }, 100);
  }

  function init() {
    // Activa o slide activo imediatamente
    const activeSlide = document.querySelector('.product__slide.media--active[data-type="video"]');
    if (activeSlide) activateSlide(activeSlide);

    // Quando o carrossel muda de slide, activa o novo
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((m) => {
        if (m.type === 'attributes' && m.attributeName === 'class') {
          const el = m.target;
          if (
            el.classList.contains('media--active') &&
            el.dataset.type === 'video'
          ) {
            activateSlide(el);
          }
        }
      });
    });

    // Observa todos os slides de video para mudancas de classe
    document.querySelectorAll('.product__slide[data-type="video"]').forEach((slide) => {
      observer.observe(slide, { attributes: true, attributeFilter: ['class'] });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
